<template>
    <v-container fluid grid-list-md>
        <v-layout>
            <v-flex>
                <h1 class="display-3">Movimientos</h1>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <v-data-table :headers="headers" :items="items" class="elevation-1">
                    <template slot="items" slot-scope="props">
                        <td class="text-xs-center">{{ props.item.D3_EMISSAO }}</td>
                        <td class="text-xs-center">{{ props.item.D3_LOCAL }}</td>
                        <td class="text-xs-right">{{ props.item.D3_COD }}</td>
                        <td class="text-xs-center">{{ props.item.D3_UM }}</td>
                        <td class="text-xs-right">{{ props.item.D3_QUANT }}</td>
                        <td class="text-xs-right">{{ props.item.acum }}</td>
                        <td class="text-xs-center">
                            <v-tooltip top>
                                <span slot="activator">{{ props.item.cf }}</span>
                                <span>{{ props.item.D3_CF }}</span>
                            </v-tooltip>
                        </td>
                        <td class="text-xs-center">
                            <v-tooltip top>
                                <v-icon :color="props.item.tm_color" slot="activator">{{ props.item.tm_icon }}</v-icon>
                                <span>{{ props.item.D3_TM }}</span>
                            </v-tooltip>
                        </td>
                        <td class="text-xs-right">{{ props.item.D3_DOC }}</td>
                        <td class="text-xs-right">{{ props.item.D3_CUSTO1 }}</td>
                        <td class="text-xs-right">{{ props.item.D3_CUSTO2 }}</td>
                        <td class="text-xs-right">{{ props.item.D3_CUSTO3 }}</td>
                        <td class="text-xs-right">{{ props.item.D3_CUSTO4 }}</td>
                        <td class="text-xs-right">{{ props.item.D3_USUARIO }}</td>
                        <td class="text-xs-right">{{ props.item.D3_ESTORNO }}</td>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
        <v-btn @click.native="datos()">test</v-btn>
    </v-container>
</template>

<script>
    export default {
        name: "kardex",
        data() {
            return {
                d: {
                    desde: '2001-01-01',
                    hasta: '2019-01-01',
                    emp: 1,
                    prod: '3210.00028',
                    dep: 'D1'
                },
                headers: [
                    {text: 'F. emisión', value: 'D3_EMISSAO'},
                    {text: 'Depósito', value: 'deposito'},
                    {text: 'Código', value: 'D3_COD'},
                    {text: 'UM', value: 'D3_UM'},
                    {text: 'Cant', value: 'D3_QUANT'},
                    {text: 'Acumulado', value: 'acum'},
                    {text: 'Tipo Sol/Dev', value: 'D3_CF'},
                    {text: 'Tipo de Transaccion ', value: 'D3_TM'},
                    {text: 'Documento', value: 'D3_DOC'},
                    {text: 'Costo 1', value: 'D3_CUSTO1'},
                    {text: 'Costo 2', value: 'D3_CUSTO2'},
                    {text: 'Costo 3', value: 'D3_CUSTO3'},
                    {text: 'Costo 4', value: 'D3_CUSTO4'},
                    {text: 'Usuario', value: 'D3_USUARIO'},
                    {text: 'Retorno', value: 'D3_ESTORNO'},
                ],
                items: []
            }
        },
        methods: {
            datos() {
                this.$http.post('informes/movimientos/producto', this.d)
                    .then(r => {
                        this.items = r.data;
                    })
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/informes/movimientos.vue